// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectToDosTileQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectToDosTileQuery = { __typename?: 'Query', toDos: Array<{ __typename?: 'ToDo', id: string, createdAt: Types.Scalars['DateTime']['input'], name: string, createdBy: { __typename?: 'User', avatarUrl: string, id: string, name: string }, parent?: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Cohort', id: string, name: string } | { __typename?: 'Development', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } | null | undefined }> };

export type ProjectToDosTile_ToDoFragment = { __typename?: 'ToDo', id: string, createdAt: Types.Scalars['DateTime']['input'], name: string, createdBy: { __typename?: 'User', avatarUrl: string, id: string, name: string }, parent?: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Cohort', id: string, name: string } | { __typename?: 'Development', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } | null | undefined };

export const ProjectToDosTile_ToDoFragmentDoc = gql`
    fragment ProjectToDosTile_ToDo on ToDo {
  id
  createdAt
  createdBy {
    avatarUrl
    id
    name
  }
  name
  parent {
    ... on Named {
      id
      name
    }
  }
}
    `;
export const ProjectToDosTileDocument = gql`
    query ProjectToDosTile($projectId: ID!) {
  toDos(filter: {project: [$projectId]}, limit: 15) {
    ...ProjectToDosTile_ToDo
  }
}
    ${ProjectToDosTile_ToDoFragmentDoc}`;

/**
 * __useProjectToDosTileQuery__
 *
 * To run a query within a React component, call `useProjectToDosTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectToDosTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectToDosTileQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectToDosTileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectToDosTileQuery, ProjectToDosTileQueryVariables> & ({ variables: ProjectToDosTileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectToDosTileQuery, ProjectToDosTileQueryVariables>(ProjectToDosTileDocument, options);
      }
export function useProjectToDosTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectToDosTileQuery, ProjectToDosTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectToDosTileQuery, ProjectToDosTileQueryVariables>(ProjectToDosTileDocument, options);
        }
export function useProjectToDosTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectToDosTileQuery, ProjectToDosTileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectToDosTileQuery, ProjectToDosTileQueryVariables>(ProjectToDosTileDocument, options);
        }
export type ProjectToDosTileQueryHookResult = ReturnType<typeof useProjectToDosTileQuery>;
export type ProjectToDosTileLazyQueryHookResult = ReturnType<typeof useProjectToDosTileLazyQuery>;
export type ProjectToDosTileSuspenseQueryHookResult = ReturnType<typeof useProjectToDosTileSuspenseQuery>;
export type ProjectToDosTileQueryResult = Apollo.QueryResult<ProjectToDosTileQuery, ProjectToDosTileQueryVariables>;